import getters from './getters'
import mutations from './mutations'
import actions from './actions'
const state = {
  mailingList: '',
  mailReportData: ''
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/mailing/index.js